import { slugify } from 'utils/string-helpers';

export default (rawAttributes, benchmarks) => {
  return rawAttributes.map(rawAttr => {
    const row = { attribute: rawAttr.attribute, isActive: true };
    benchmarks.forEach((benchmark, index) => {
      row[slugify(benchmark.name)] = rawAttr.values[index];
    });
    return row;
  });
};
